import popup from './popup';
import common from './common';
import router from '../router';
import tools from './tools';
const CancelToken = axios.CancelToken;
var root = '';
// if (common.env == 1) {
//   root = location.origin.replace("http://","https://");
// }
// root = "https://prepare.fxyf99.com"
// root = "https://www.fxyf99.com"
// 引用axios
import axios from 'axios';
axios.defaults.withCredentials = true;
// 自定义判断元素类型JS
function toType(obj) {
  return ({}).toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase()
}
// 参数过滤函数
function filterNull(o) {
  for (var key in o) {
    if (o[key] === null) {
      delete o[key]
    }
    if (toType(o[key]) === 'string') {
      o[key] = o[key].trim()
    } else if (toType(o[key]) === 'object') {
      o[key] = filterNull(o[key])
    } else if (toType(o[key]) === 'array') {
      o[key] = filterNull(o[key])
    }
  }
  return o
}
/*
  接口处理函数
  这个函数每个项目都是不一样的，我现在调整的是适用于
  https://cnodejs.org/api/v1 的接口，如果是其他接口
  需要根据接口的参数进行调整。参考说明文档地址：
  https://cnodejs.org/topic/5378720ed6e2d16149fa16bd
  主要是，不同的接口的成功标识和失败提示是不一致的。
  另外，不同的项目的处理方法也是不一致的，这里出错就是简单的alert
*/

function apiAxios(params) {
  return new Promise((resolved, rejected) => {
    const method = params.type?params.type.toUpperCase():"POST"
    let query=getQuerys(params.query);
    if (params.params) {
      params.params = filterNull(params.params)
      var time = (new Date()).valueOf();
      params.params.time = time;
    }
    if(common.channel == "BJ") {
      if(params.url.includes("/wechatthirdplat/")) {
        params.url = "https://fans.fxyf99.com"+params.url
      }
    }
    axios({
      method: method,
      url: params.url+query,
      data: method === 'POST' || method === 'PUT' || method === 'DELETE' ? params.params : null,
      params: method === 'GET' ? params.params : null,
      baseURL: root,
      responseType: params.responseType || '',
      // headers:{'WTS_TOKEN_A':common.token?common.token:''},
      headers:params.headers,
      cancelToken: new CancelToken(function executor(c) {
        tools.$httpRequestList.push(c);
        tools.$httpRequestList = tools.$httpRequestList.slice(-10); //只保留最新的10个请求
      }),
      withCredentials: true
    })
      .then(function (res) {
        if (params.forced) {
          if (params.All) {
            resolved(res)
          } else {
            resolved(res.data)
          }
          return;
        }
        var ok = successError(res);
        if (!ok) {
          rejected(res);
          return
        }
        resolved(res.data);
      })
      .catch(function (e) {
        console.log(e);
        rejected(e);
        if(!e || e.message != '取消请求') {
          popup.msg("网络连接有误", 2, 1500)
        }
      })
  })

}
// 拼接接口后缀参数
function getQuerys(data){
  if(!data)return "";
  let paramStr = '';
  Object.keys(data).forEach((item) => {
    if (paramStr === '') {
      paramStr = `?${item}=${data[item]}`;
    } else {
      paramStr = `${paramStr}&${item}=${data[item]}`;
    }
  });
  return paramStr;
}
//公共错误处理
function successError(data) {
  //服务器出错
  if (data.data.httpCode != 200 && data.data.httpCode != 1) {
    if (data.data.httpCode == 301 || data.data.httpCode == 401) {
      router.push('/login')
      return false;
    }
    if (data.data.data) {
      popup.msg(data.data.data, 2, 1500)
    } else {
      popup.msg(data.data.msg, 2, 1500)
    }
    return false;
  }
  return true
}

// 返回在vue模板中的调用接口
export default apiAxios
